// CrearOrdenCompraDialog.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  Divider,
  Stack,
  Autocomplete,
  Grid,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import { Add, Clear, RemoveCircleOutline } from '@mui/icons-material';
import AutocompleteWithAdd from '../../../../components/AutocompleteWithAdd';
import ProductsForm from '../../productos/productsform';
import { fetchProveedores, fetchProductosPorCategoria, fetchAlmacenes, fetchMonedas  } from '../../../../utils/generalsFetch';
import CrearProveedorDialog from '../proveedores/crearproveedordialog';
import Selector from '../../../../components/Selector';
import { useNavigate } from 'react-router-dom';
import AppTheme from '../../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
  } from '../../../dashboard/theme/customizations';
import SideMenu from '../../../../components/SideMenu';
import AppNavbar from '../../../../components/AppNavbar';
import { alpha } from '@mui/material/styles';
import Header from '../../../../components/Header';
import SelectBuyerOrdersDialog from './selectbuyerorderdialog';

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };

const CrearFacturaProveedor = (props) => {
  const navigate = useNavigate();
  const [openCrearProveedor, setOpenCrearProveedor] = useState(false)
  const [proveedor, setProveedor] = useState({});
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputValueProducto, setInputValueProducto] = useState('');
  const [openCrearProducto, setOpenCrearProducto] = useState(false);
  const [fechaEmision, setFechaEmision] = useState(new Date());
  const [fechaVencimiento, setFechaVencimiento] = useState(new Date());
  const [terminosCondiciones, setTerminosCondiciones] = useState('');
  const [subtotal, setSubtotal] = useState(0);
  const [impuestos, setImpuestos] = useState(0);
  const [total, setTotal] = useState(0);
  const [observaciones, setObservaciones] = useState('');
  const [estado, setEstado] = useState('abierta');
  const [almacenes, setAlmacenes] = useState([]);
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState(null);
  const [errorAlmacen, setErrorAlmacen] = useState('');
  const [errorProveedor, setErrorProveedor] = useState('');
  const [errorProductos, setErrorProductos] = useState('');
  const [errorFechaEmision, setErrorFechaEmision] = useState('');
  const [errorFechaVencimiento, setErrorFechaVencimiento] = useState('');
  const [errorMoneda, setErrorMoneda] = useState('');
  const [errorGeneral, setErrorGeneral] = useState('');
  const [openSeleccionarOrdenCompra, setOpenSeleccionarOrdenCompra] = useState(false);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [ordenesCompraSeleccionadas, setOrdenesCompraSeleccionadas] = useState([]);
  const [productosFinales, setProductosFinales] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [moneda, setMoneda] = useState(null);
  const [openCrearMonedaDialog, setOpenCrearMonedaDialog] = useState(false);

  React.useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setMonedas(data);
    });
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
    });
    fetchProductosPorCategoria({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany'), tipocategoria: "generico" }).then((data) => {
      setProductos(data);
    });
    fetchAlmacenes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setAlmacenes(data);
      setAlmacenSeleccionado(data[0].value);
      handleGetOrdenesCompra(data[0].value);
    });
    
  }, []); 

  React.useEffect(() => {
    handleCalcularTotales();
  }, [productosFinales]);

  const handleAdd = (newValue) => {
    setOpenCrearProveedor(true)
    const newOption = { label: newValue };
    setProveedores((prev) => [...prev, newOption]);
  };

  const handleGetOrdenesCompra = async (almacen) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL+`/api/ordenes-compra/${localStorage.getItem('idcompany')}?estado=recibida`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
    });
    const data = await response.json();
    setOrdenesCompra(data.filter(orden => orden.id_almacen == almacen));
  }

  const handleCrearProducto = () => {
    setOpenCrearProducto(false)
    fetchProductosPorCategoria({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany'), tipocategoria: "generico" }).then((data) => {
      setProductos(data);
      
    });
  }

  const handleCalcularTotales = () => {
    setSubtotal(productosFinales.reduce((acc, producto) => acc + parseFloat(producto.subtotal), 0));
    setImpuestos(productosFinales.reduce((acc, producto) => acc + parseFloat(producto.impuestos), 0));
    setTotal(productosFinales.reduce((acc, producto) => acc + parseFloat(producto.subtotal) + parseFloat(producto.impuestos), 0));
  }

  const validateFields = () => {
    let valid = true;
    setErrorProveedor('');
    setErrorProductos('');
    setErrorFechaEmision('');
    setErrorFechaVencimiento('');
    setErrorGeneral('');
    setErrorMoneda('');
    if (!proveedor || !proveedor.value) {
      setErrorProveedor('Seleccione un proveedor.');
      valid = false;
    }
    if (!almacenSeleccionado) {
      setErrorAlmacen('Seleccione un almacen.');
      valid = false;
    }
    if (!moneda || !moneda.value) {
      setErrorMoneda('Seleccione una moneda.');
      valid = false;
    }
    if (!productosFinales || productosFinales.length === 0) {
      setErrorProductos('Agregue al menos un producto.');
      valid = false;
    }
    if (!fechaEmision) {
      setErrorFechaEmision('Ingrese la fecha de emisión.');
      valid = false;
    }
    if (!fechaVencimiento) {
      setErrorFechaVencimiento('Ingrese la fecha de vencimiento.');
      valid = false;
    }

    return valid;
  };

  const handleGuardarOrden = async () => {
    
    if (!validateFields()) {
      setErrorGeneral('Por favor corrija los errores antes de guardar.');
      return;
    }
      const response = await fetch(process.env.REACT_APP_SERVER_URL+'/api/facturas-compra', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
      body: JSON.stringify({
        id_proveedor: proveedor.value,
        detalles: productosFinales.map(producto => ({
          id_producto: producto.id_producto,
          descripcion_producto: producto.nombre,
          cantidad: producto.cantidad,
          precio: producto.precio,
          impuestos: producto.impuestos,
          subtotal: producto.subtotal,
          id_orden_compra: producto.id_orden_compra
        })),
        fecha_emision: fechaEmision,
        fecha_vencimiento: fechaVencimiento,
        observaciones: observaciones,
        total_estimado: total,
        estado: estado,
        idcompany: localStorage.getItem('idcompany'),
        usuario_creador: localStorage.getItem('id'),
        id_almacen: almacenSeleccionado,
        id_moneda: moneda.value
      }),
    });
    if (response.ok) {
      onClose();
    }
    else{
      alert(response.statusText)
    }
  }

  const onClose = () => {
    navigate(-1);
  }

  const handleAddProveedor = () => {
    setOpenCrearProveedor(false)
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
    });
  }

  const confirmOrdenesCompra = (value) => {
    setOrdenesCompraSeleccionadas(value);
    setOpenSeleccionarOrdenCompra(false);
    const productos = value.map(orden => JSON.parse(orden.detalles_productos)).flat();
  
    const mezclados = [...productos, ...productosSeleccionados];
    setProductosFinales(mezclados);

  }

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <SelectBuyerOrdersDialog orders={ordenesCompra} selected={ordenesCompraSeleccionadas} open={openSeleccionarOrdenCompra} onClose={()=>{setOpenSeleccionarOrdenCompra(false)}} onConfirm={(value)=>{confirmOrdenesCompra(value)}}/>
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}>
                <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}>
                <Header parent={"Logistica y Almacenes"} child={"Facturas de Proveedores"}/>
                <br></br>
                {openCrearProducto && <ProductsForm  onClose={()=>{handleCrearProducto()}} />}
                <CrearProveedorDialog open={openCrearProveedor}  onClose={()=>{handleAddProveedor()}} />
                {!openCrearProducto && (
                    <Box boxShadow={1} px={5} py={5} sx={{width:"100%"}}>

                        <Box display="flex" justifyContent="space-between" alignItems="center" >
                            <Typography variant="h6" fontWeight={700}>Crear Factura de Proveedor</Typography>
                            <Button onClick={onClose}><DeleteIcon /></Button>
                        </Box>
                        <Box dividers>
                            <Box mb={2}>
                                <Stack spacing={2} mt={1}>
                                    <AutocompleteWithAdd
                                    label="Proveedor"
                                    options={proveedores}
                                    value={proveedor}
                                    onChange={(val) => {
                                        setProveedor(val); 
                                        setOrdenesCompra(ordenesCompra.filter(orden => orden.id_proveedor == val.value))
                                    }}
                                    onAdd={handleAdd}
                                    error={!!errorProveedor}
                                    />
                                    {errorProveedor && <Typography color="error" fontSize={13} textAlign={"left"}>{errorProveedor}</Typography>}
                                    
                                    <Grid container spacing={2}>
                                      <Grid item size={6}>
                                        <Selector placeholder="Selecciona un almacen" options={almacenes} value={almacenSeleccionado} onChange={((e) => setAlmacenSeleccionado(e.target.value))}/>
                                        {errorAlmacen && <Typography color="error" fontSize={13} textAlign={"left"}>{errorAlmacen}</Typography>}
                                      </Grid>
                                      <Grid item size={6}>
                                        <AutocompleteWithAdd label='Moneda' options={monedas} value={moneda} onChange={(val) => setMoneda(val)} onAdd={() => setOpenCrearMonedaDialog(true)} /> 
                                      </Grid>
                                      {errorMoneda && <Typography color="error" fontSize={13} textAlign={"left"}>{errorMoneda}</Typography>}
                                    <Grid item size={6}>
                                        <Typography fontSize={12} fontWeight={600} textAlign={"left"}>Fecha de Emisión</Typography>
                                        <TextField placeholder="Fecha de Emisión" fullWidth type='date' value={fechaEmision} onChange={(e) => setFechaEmision(e.target.value)} error={!!errorFechaEmision}/>
                                        {errorFechaEmision && <Typography color="error" fontSize={13} textAlign={"left"}>{errorFechaEmision}</Typography>}
                                    </Grid>
                                    <Grid item size={6}>
                                        <Typography fontSize={12} fontWeight={600} textAlign={"left"}>Fecha de Vencimiento</Typography>
                                        <TextField placeholder="Fecha de Vencimiento" fullWidth type='date' value={fechaVencimiento} onChange={(e) => setFechaVencimiento(e.target.value)} error={!!errorFechaVencimiento}/>
                                        {errorFechaVencimiento && <Typography color="error" fontSize={13} textAlign={"left"}>{errorFechaVencimiento}</Typography>}
                                    </Grid>
                                    </Grid>
                                    
                                    <TextField placeholder="Términos y Condiciones (Opcional)" fullWidth value={terminosCondiciones} onChange={(e) => setTerminosCondiciones(e.target.value)}/>
                                </Stack>
                            </Box>

                            <Divider sx={{ my: 2, mt: 5 }} />
                            <Autocomplete
                                options={productos}
                                value={selectedProduct}
                                inputValue={inputValueProducto}
                                onInputChange={(event, newInputValue) => setInputValueProducto(newInputValue)}
                                onChange={(event, value) => {
                                    if (value) {
                                    console.log(value)
                                    setProductosSeleccionados(prev => [...prev, {...value, cantidad:1, impuestos:0, subtotal:value.precio, id_orden_compra:null}]);
                                    setProductosFinales(prev => [...prev, {...value, cantidad:1, impuestos:0, subtotal:value.precio, id_orden_compra:null}]);
                                    setSelectedProduct(null); 
                                    setInputValueProducto('');
                                    }
                                }}
                                getOptionLabel={(option) => option.nombre}
                                renderInput={(params) => <TextField {...params} placeholder="Buscar Producto" />}
                            />
                            {errorProductos && <Typography color="error" fontSize={13} textAlign={"left"} sx={{mt:1,mb:1}}>{errorProductos}</Typography>}
                            <br></br>

                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                    <StyledCellHeader>Producto</StyledCellHeader>
                                    <StyledCellHeader>Cantidad</StyledCellHeader>
                                    <StyledCellHeader>Precio Unitario</StyledCellHeader>
                                    <StyledCellHeader>Impuestos</StyledCellHeader>
                                    <StyledCellHeader>Subtotal</StyledCellHeader>
                                    <StyledCellHeader align="right"></StyledCellHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productosSeleccionados.map((producto, idx) => (
                                    <TableRow key={producto.id || idx}>
                                        <TableCell>{producto.nombre === '' ? producto.id : producto.nombre}</TableCell>
                                        <TableCell>
                                        <TextField
                                            type="number"
                                            value={producto.cantidad}
                                            onChange={(e) => {
                                            setProductosSeleccionados(prev =>
                                                prev.map((p, i) =>
                                                i === idx ? { ...p, cantidad: e.target.value, subtotal: e.target.value * p.precio } : p
                                                )
                                            );
                                            setProductosFinales(prev =>
                                                prev.map((p, i) =>
                                                p.id === producto.id ? { ...p, cantidad: e.target.value, subtotal: e.target.value * p.precio } : p
                                                )
                                            );
                                            }}

                                        />
                                        </TableCell>
                                        <TableCell>
                                        <TextField
                                            type="number"
                                            value={producto.precio}
                                            onChange={(e) => {
                                            setProductosSeleccionados(prev =>
                                                prev.map((p, i) =>
                                                i === idx ? { ...p, precio: e.target.value, subtotal: e.target.value * p.cantidad } : p
                                                )
                                            );
                                            setProductosFinales(prev =>
                                                prev.map((p, i) =>
                                                p.id === producto.id ? { ...p, precio: e.target.value, subtotal: e.target.value * p.cantidad } : p
                                                )
                                            );
                                            }}
                                        />
                                        </TableCell>
                                        <TableCell>
                                        <TextField
                                            type="number"
                                            value={producto.impuestos}
                                            onChange={(e) => {
                                            setProductosSeleccionados(prev =>
                                                prev.map((p, i) =>
                                                i === idx ? { ...p, impuestos: e.target.value } : p
                                                )
                                            );
                                            setProductosFinales(prev =>
                                                prev.map((p, i) =>
                                                p.id === producto.id ? { ...p, impuestos: e.target.value } : p
                                                )
                                            );
                                            }}
                                        />
                                        </TableCell>
                                        <TableCell>
                                        <TextField type="number" value={producto.subtotal} disabled />
                                        </TableCell>
                                        <TableCell align="right">
                                        <IconButton color="error" size="small" onClick={() => {
                                            setProductosSeleccionados(prev => prev.filter((_, i) => i !== idx));
                                            setProductosFinales(prev => prev.filter((_, i) => i !== idx));
                                        }}>
                                            <RemoveCircleOutline fontSize="small" color="error" />
                                        </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <Box mt={2} display={"flex"}>
                                <Button sx={{borderColor:"primary.main",color:"primary.main"}} startIcon={<Add sx={{color:"primary.main"}}/>} variant="outlined" onClick={()=>{setOpenCrearProducto(true)}}> Crear Producto</Button>
                            </Box>

                            {ordenesCompraSeleccionadas.length > 0 && (
                                <Box mt={3}>
                                    {ordenesCompraSeleccionadas.map((orden, idx) => (
                                        <Box key={idx} textAlign={"left"}>
                                            <Box display={"flex"} justifyContent={"space-between"}>
                                                <Typography fontSize={16} fontWeight={600}>{orden.nombre || orden.name || `Orden #${orden.numero || orden.numero_orden}`}</Typography>
                                                <IconButton onClick={()=>{
                                                    setOrdenesCompraSeleccionadas(ordenesCompraSeleccionadas.filter((_, i) => i !== idx));
                                                    setProductosFinales(productosFinales.filter((producto) => producto.id_orden_compra !== orden.id));
                                                }}>
                                                    <Clear/>
                                                </IconButton>
                                            </Box>
                                            <Table size="small" sx={{mt:1}}>
                                                <TableHead>
                                                    <TableRow>
                                                    <StyledCellHeader>Producto</StyledCellHeader>
                                                    <StyledCellHeader>Cantidad</StyledCellHeader>
                                                    <StyledCellHeader>Precio Unitario</StyledCellHeader>
                                                    <StyledCellHeader>Impuestos</StyledCellHeader>
                                                    <StyledCellHeader>Subtotal</StyledCellHeader>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {JSON.parse(orden.detalles_productos).map((producto, idx) => (
                                                    <TableRow key={producto.id || idx}>
                                                        <TableCell>{producto.nombre === '' ? producto.id : producto.nombre}</TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                disabled
                                                                type="number"
                                                                value={producto.cantidad}
                                                                onChange={(e) => {
                                                                setProductosSeleccionados(prev =>
                                                                    prev.map((p, i) =>
                                                                    i === idx ? { ...p, cantidad: e.target.value, subtotal: e.target.value * p.precio } : p
                                                                    )
                                                                );
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                disabled
                                                                type="number"
                                                                value={producto.precio}
                                                                onChange={(e) => {
                                                                setProductosSeleccionados(prev =>
                                                                    prev.map((p, i) =>
                                                                    i === idx ? { ...p, precio: e.target.value, subtotal: e.target.value * p.cantidad } : p
                                                                    )
                                                                );
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                        <TextField
                                                            disabled
                                                            type="number"
                                                            value={producto.impuestos}
                                                            onChange={(e) => {
                                                            setProductosSeleccionados(prev =>
                                                                prev.map((p, i) =>
                                                                i === idx ? { ...p, impuestos: e.target.value } : p
                                                                )
                                                            );
                                                            }}
                                                        />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField type="number" value={producto.subtotal} disabled />
                                                        </TableCell>
                                                    </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                        </Box>
                                        
                                    ))}
                                </Box>
                            )}

                            {proveedor.value && (
                            <Box mt={2} display={"flex"} justifyContent={"flex-end"}>
                                <Button sx={{borderColor:"primary.main",color:"primary.main", fontWeight:"bold"}} startIcon={<Add sx={{color:"primary.main"}}/>} variant="outlined" onClick={()=>{setOpenSeleccionarOrdenCompra(true)}}> Agregar Orden de Compra</Button>
                            </Box>
                            )}

                            <Divider sx={{ my: 2 }} />

                            <Typography variant="subtitle1" fontWeight={600} textAlign={"left"}>Totales</Typography>
                            <Box display="flex" flexDirection="column" gap={1} mt={1}>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>Subtotal</Typography>
                                <Typography>${subtotal}</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>Impuestos</Typography>
                                <Typography>${impuestos}</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Typography>Total</Typography>
                                <Typography>${total}</Typography>
                            </Box>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={"flex-end"} marginTop={5}>
                            <Button onClick={onClose} variant="outlined" sx={{marginRight:5}}>Cancelar</Button>
                            <Button color='primarybutton' sx={{fontWeight:"bold"}} onClick={handleGuardarOrden} variant="contained">Guardar Orden</Button>
                        </Box>
                    </Box>
                )}
                </Stack>
            </Box>
        </Box>
    </AppTheme>
  );
};

export default CrearFacturaProveedor;
